import { Post } from "@/types/type";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { Image } from "expo-image";
import { router } from "expo-router";
import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

const PostCard = ({
  post: post,
  styling,
}: {
  post: Post;
  styling?: string;
}) => {
  const startDate = new Date(post.when);
  const formattedDate = `${startDate.getDate()}`;
  const formattedMonth = startDate.toLocaleString("default", {
    month: "short",
  });
  const imageSource = post.image_url
    ? post.image_url
    : post.media_urls?.[0]?.url
      ? post.media_urls[0].url
      : require("../assets/images/photo.svg");

  return (
    <View
      className={`p-4 rounded-lg shadow-none w-full items-center ${styling} m-1
      ${
        post?.suggestion?.[0]?.type === "ad"
          ? "bg-amber-200"
          : post?.suggestion?.[0]?.type === "suggestion"
            ? "bg-gray-200"
            : "bg-white"
      }`}
    >
      <TouchableOpacity
        onPress={() => router.push(`/post-details?id=${post.id}`)}
        className="w-full"
      >
        <View className="relative w-full h-[150px]">
          <Image
            source={
              post.image_url
                ? post.image_url
                : require("../assets/images/photo.svg")
            }
            style={styles.image}
            contentFit="contain"
            transition={500}
            cachePolicy={"memory-disk"}
          />

          <View className="absolute top-2 left-2 bg-white/90 rounded-lg px-2 py-1 h-[50px] flex justify-center items-center">
            <Text className="text-xs font-bold text-orange-600">
              {formattedDate}
            </Text>
            <Text className="text-[10px] uppercase font-semibold text-gray-500">
              {formattedMonth}
            </Text>
            <Text className="text-[10px] uppercase font-semibold text-gray-500">
              {post.category}
            </Text>
          </View>
        </View>

        <View className="w-full">
          <Text className="text-xl font-semibold text-gray-900 mt-2 mb-2 line-clamp-2">
            {post.description}
          </Text>

          {post.place && (
            <View className="flex-row items-center mt-2 justify-between pr-12">
              <View className="flex-row items-center">
                <FontAwesome name="map-marker" size={16} color="black" />
                <Text className="text-gray-500 text-xs flex-1">
                  {post.place?.city} - {post.place?.title}
                </Text>
              </View>
            </View>
          )}

          {post.busker && (
            <View className="flex-row items-center mt-2 justify-between pr-12">
              <View className="flex-row items-center">
                <FontAwesome name="user" size={16} color="black" />
                <Text className="text-gray-500 text-xs flex-1 pl-2">
                  {post.busker?.full_name}
                </Text>
              </View>
            </View>
          )}
        </View>
        <View className="absolute right-0 p-3">
          <TouchableOpacity
            onPress={() => {
              router.push(`/comments?id=${post.id}&type=post`);
            }}
          >
            <FontAwesome name="comment" size={24} color="black" />
            <Text> {post.comments_num}</Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    //flex: 1,
    //backgroundColor: '#fff',
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    flex: 1,
    width: "100%",
    fontSize: 100,
    alignItems: "center",
    justifyContent: "center",

    //backgroundColor: '#0553',
  },
});
export default PostCard;
